import { X2Heading } from './2XHeading';
import X2ImageCopy from './2XImageCopy';
import Heading from './Heading';
import Highlights from './Highlights';
import ImageCopy from './ImageCopy';
import Quicklinks from './Quicklinks';
import Slideshow from './Slideshow';
import Stats from './Stats';
import Video from './Video';
import Accordion from './Accordion';
import ContactFormSection from './ContactFormSection';
import Copy from './Copy';
import ImageSection from './ImageSection';
import Collage from './Collage';
import { X2Copy } from './X2Copy';
import InteractiveMap from './InteractiveMap'
import Timeline from './Timeline';
import AmenitiesSection from './AmenitiesSection';
import Floorplans from './Floorplans';
import Pricelist from './Pricelist';

export const allComponents = {
    imageCopy: ImageCopy,    
    highlights: Highlights,
    heading: Heading,
    quickLinks: Quicklinks,
    slideshow: Slideshow,
    xImageCopy: X2ImageCopy,
    video: Video,
    stats: Stats,
    x2Heading: X2Heading,
    accordion: Accordion,
    contactForm: ContactFormSection,
    copy: Copy,
    image: ImageSection,
    collage: Collage,
    x2Copy: X2Copy,
    map: InteractiveMap,
    timeline: Timeline,
    amenitiesSlider: AmenitiesSection,
    floorplans: Floorplans,
    pricelist: Pricelist
}
